import React from "react";

function Mumbai(props: React.SVGProps<SVGSVGElement>) {
  return (
    <svg viewBox="0 0 24 24" fill="none" {...props}>
      <path
        d="M4.02075 7.9375H20.4452V9.31166H4.02075V7.9375Z"
        stroke="#17142A"
        strokeWidth="0.348155"
        strokeMiterlimit="10"
      />
      <path
        d="M3.36548 9.36377H21.0987V12.0467H3.36548V9.36377Z"
        stroke="#17142A"
        strokeWidth="0.348155"
        strokeMiterlimit="10"
      />
      <path
        d="M2.48071 12.0596H21.9807V20.0428H2.48071V12.0596Z"
        stroke="#17142A"
        strokeWidth="0.348155"
        strokeMiterlimit="10"
      />
      <path
        d="M9.06885 9.36377V20.043"
        stroke="#17142A"
        strokeWidth="0.348155"
        strokeMiterlimit="10"
      />
      <path
        d="M15.417 9.36377V20.043"
        stroke="#17142A"
        strokeWidth="0.348155"
        strokeMiterlimit="10"
      />
      <path
        d="M17.3152 9.36377V20.043"
        stroke="#17142A"
        strokeWidth="0.348155"
        strokeMiterlimit="10"
      />
      <path
        d="M7.17212 9.36377V20.043"
        stroke="#17142A"
        strokeWidth="0.348155"
        strokeMiterlimit="10"
      />
      <path
        d="M9.84246 7.93748V5.37761C9.83016 5.15164 9.73172 4.93897 9.5674 4.78336C9.40309 4.62774 9.18538 4.54102 8.95907 4.54102C8.73276 4.54102 8.51506 4.62774 8.35074 4.78336C8.18642 4.93897 8.08799 5.15164 8.07568 5.37761V7.93748H9.84246Z"
        stroke="#17142A"
        strokeWidth="0.348155"
        strokeMiterlimit="10"
      />
      <path
        d="M8.9563 4.49534V3.49023"
        stroke="#17142A"
        strokeWidth="0.348155"
        strokeMiterlimit="10"
        strokeLinecap="round"
      />
      <path
        d="M16.4384 7.93748V5.37761C16.4261 5.15164 16.3277 4.93897 16.1634 4.78336C15.999 4.62774 15.7813 4.54102 15.555 4.54102C15.3287 4.54102 15.111 4.62774 14.9467 4.78336C14.7824 4.93897 14.6839 5.15164 14.6716 5.37761V7.93748H16.4384Z"
        stroke="#17142A"
        strokeWidth="0.348155"
        strokeMiterlimit="10"
      />
      <path
        d="M15.5527 4.49534V3.49023"
        stroke="#17142A"
        strokeWidth="0.348155"
        strokeMiterlimit="10"
        strokeLinecap="round"
      />
      <path
        d="M8.07568 6.63135H16.4384"
        stroke="#17142A"
        strokeWidth="0.348155"
        strokeMiterlimit="10"
      />
      <path
        d="M13.8023 19.9905V15.1901C13.8023 14.7736 13.6369 14.3741 13.3423 14.0796C13.0478 13.7851 12.6484 13.6196 12.2318 13.6196C11.8153 13.6196 11.4159 13.7851 11.1214 14.0796C10.8268 14.3741 10.6614 14.7736 10.6614 15.1901V19.9905H13.8023Z"
        stroke="#17142A"
        strokeWidth="0.348155"
        strokeMiterlimit="10"
      />
      <path
        d="M20.913 19.9906V16.0854C20.9209 15.9126 20.8936 15.74 20.8329 15.5781C20.7721 15.4161 20.6792 15.2682 20.5597 15.1431C20.4402 15.0181 20.2966 14.9186 20.1376 14.8506C19.9785 14.7826 19.8074 14.7476 19.6344 14.7476C19.4615 14.7476 19.2903 14.7826 19.1313 14.8506C18.9722 14.9186 18.8286 15.0181 18.7091 15.1431C18.5896 15.2682 18.4967 15.4161 18.436 15.5781C18.3753 15.74 18.348 15.9126 18.3558 16.0854V19.9906H20.913Z"
        stroke="#17142A"
        strokeWidth="0.348155"
        strokeMiterlimit="10"
      />
      <path
        d="M18.356 16.0854H20.9132"
        stroke="#17142A"
        strokeWidth="0.348155"
        strokeMiterlimit="10"
      />
      <path
        d="M6.21139 19.9906V16.0854C6.21921 15.9126 6.19193 15.74 6.1312 15.5781C6.07047 15.4161 5.97755 15.2682 5.85805 15.1431C5.73855 15.0181 5.59494 14.9186 5.43591 14.8506C5.27688 14.7826 5.10572 14.7476 4.93277 14.7476C4.75981 14.7476 4.58865 14.7826 4.42962 14.8506C4.27059 14.9186 4.12698 15.0181 4.00748 15.1431C3.88798 15.2682 3.79506 15.4161 3.73433 15.5781C3.6736 15.74 3.64632 15.9126 3.65414 16.0854V19.9906H6.21139Z"
        stroke="#17142A"
        strokeWidth="0.348155"
        strokeMiterlimit="10"
      />
      <path
        d="M3.64575 16.0854H6.203"
        stroke="#17142A"
        strokeWidth="0.348155"
        strokeMiterlimit="10"
      />
      <path
        d="M2.48071 13.6719H7.17118"
        stroke="#17142A"
        strokeWidth="0.348155"
        strokeMiterlimit="10"
      />
      <path
        d="M17.1914 13.6719H21.8819"
        stroke="#17142A"
        strokeWidth="0.348155"
        strokeMiterlimit="10"
      />
      <path
        d="M4.38452 10.7041H5.99425"
        stroke="#17142A"
        strokeWidth="0.348155"
        strokeMiterlimit="10"
      />
      <path
        d="M18.3613 10.7041H19.9711"
        stroke="#17142A"
        strokeWidth="0.348155"
        strokeMiterlimit="10"
      />
    </svg>
  );
}

const MemoMumbai = React.memo(Mumbai);
export default MemoMumbai;
